var map = {
	"./JodellEcology-en/detail.vue": [
		64348,
		874,
		1064,
		1817,
		2794,
		6933,
		5822,
		4348
	],
	"./JodellEcology-jp/detail.vue": [
		79771,
		874,
		1064,
		1817,
		2794,
		6933,
		5822,
		9771
	],
	"./JodellEcology-kr/detail.vue": [
		49853,
		874,
		1064,
		1817,
		2794,
		6933,
		5822,
		9853
	],
	"./JodellEcology/detail.vue": [
		86258,
		874,
		1064,
		1817,
		2794,
		6933,
		5822,
		6258
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 35467;
module.exports = webpackAsyncContext;